import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Contract.Revisions.IRequest;
type Response = Api.Core.Contract.Revisions.IResponse;
type Headers = Api.Core.Contract.Revisions.IHeaders;
const url = '/api/Sales/Revision/:id';
export default async function contractRevisionsApi(params: { id: number }): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
}
